import { ReactElement, useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { UserContext } from "../../shared/auth/user-context";
import { isEmployeeInternal } from "../../shared/auth/user-utils";
import { HOMESCREEN_PATH } from "../../shared/routing/paths/app";
import { getCustomerLandingPath } from "../../shared/routing/paths/customer";

/**
 * Staff go to the hub: `/customer/{id}/` would render against `climatepartner-internal`, which is not
 * a customer. Both branches carry `search` over because the sidebar stamps `target_account` onto
 * service links.
 */
export const CfcLanding = (): ReactElement => {
  const { user, hasPermission } = useContext(UserContext);
  const location = useLocation();

  if (isEmployeeInternal(hasPermission)) {
    return <Navigate to={{ pathname: HOMESCREEN_PATH, search: location.search }} replace />;
  }

  return (
    <Navigate
      to={{ pathname: getCustomerLandingPath(user?.customerId ?? undefined), search: location.search }}
      replace
    />
  );
};
